<template>
  <div class="designation">
    <div class="title">
      <span class="name">
        {{ name }}
      </span>

      <span>
        <category v-if="stars" :stars="stars" class="stars" />
      </span>
    </div>

    <div v-if="location" class="location">
      <span>
        {{ location }}
      </span>
    </div>
  </div>
</template>

<script>
import category from '@/components/frontoffice/hotel/category'

export default {
  components: {
    category
  },

  props: {
    name: {
      type: String,
      required: true
    },
    stars: Number,
    address1: String,
    postCode: String,
    city: String
  },

  computed: {
    location () {
      let address = this.address1 || ''
      let postCode = this.postCode || ''
      let city = this.city || ''

      if (postCode && address.toLowerCase().includes(postCode.toLowerCase())) postCode = ''
      if (city&& address.toLowerCase().includes(city.toLowerCase())) city = ''

      let vars = [address, postCode, city].filter(val => val.length)

      return vars.join(' ')
    }
  }
}
</script>
